<template>
	<vx-card>
		<div class="vx-col">
			<div class="vx-row">
				<div class="vx-col sm:w-1/2 w-full mb-2">
					<h3>Modifier un contact de la société {{ society_name }}</h3>
				</div>
				<div class="vx-col sm:w-1/2 w-full mb-2">
					<vs-button
						class="float-right"
						radius
						color="primary"
						type="filled"
						icon-pack="feather"
						icon="icon-x"
						@click="returnPrevRoute"
					></vs-button>
				</div>
			</div>
			<div class="vx-row sm:w-1/2 w-full mt-6 mb-2 flex">
				<!-- Sélection de la société -->
				<!-- <vx-input-group class="w-full bottom">
            <template slot="prepend">
              <div class="prepend-text bg-primary">
                <span class="flex"
                  ><vs-icon icon="domain" size="small"></vs-icon
                ></span>
              </div>
            </template>
            <vs-select
              v-model="contact.societies_id"
              class="w-1/2 select-large"
              placeholder="Société"
            >
              <vs-select-item
                :key="index"
                :value="item.id"
                :text="item.name"
                v-for="(item, index) in societyOptions"
                class="w-full"
              />
            </vs-select>
          </vx-input-group> -->
			</div>
			<div
				class="vx-row w-1/4 mt-8"
				style="display: block; white-space: nowrap"
			>
				<div class="vx-col sm:w-1/2 w-full mb-2 inlineB">
					<vs-radio
						v-model="contact.civility"
						vs-name="Madame"
						vs-value="1"
						class="mr-4"
						>Madame</vs-radio
					>
				</div>
				<div class="vx-col sm:w-1/2 w-full mb-2 inlineB">
					<vs-radio v-model="contact.civility" vs-name="Monsieur" vs-value="2"
						>Monsieur</vs-radio
					>
				</div>
				<vx-tooltip
					v-if="validators['civility'] && validators['civility'].errText !== ''"
					:text="errText('civility')"
					class="ml-3"
				>
					<vs-icon icon="error" size="medium" style="color: red"></vs-icon>
				</vx-tooltip>
			</div>
			<div class="vx-row mt-5">
				<div class="vx-col sm:w-1/2 w-full mb-2" style="white-space: nowrap">
					<!-- FIRST NAME -->
					<vx-input-group class="w-full bottom">
						<template slot="prepend">
							<div class="prepend-text bg-primary">
								<span class="flex"
									><vs-icon icon="person" size="small"></vs-icon
								></span>
							</div>
						</template>
						<vs-input
							:style="styleValidator('firstname')"
							class="w-full"
							placeholder="Prénom"
							v-model="contact.firstname"
							@change="validateOne(contact.firstname, 'firstname')"
						/>
					</vx-input-group>
					<vx-tooltip
						v-if="
							validators['firstname'] && validators['firstname'].errText !== ''
						"
						:text="errText('firstname')"
						class="ml-3"
					>
						<vs-icon icon="error" size="medium" style="color: red"></vs-icon>
					</vx-tooltip>
					<!-- /FIRST NAME -->
				</div>
				<div class="vx-col sm:w-1/2 w-full mb-2" style="white-space: nowrap">
					<!-- LAST NAME -->
					<vx-input-group class="w-full bottom">
						<template slot="prepend">
							<div class="prepend-text bg-primary">
								<span class="flex"
									><vs-icon icon="person" size="small"></vs-icon
								></span>
							</div>
						</template>
						<vs-input
							:style="styleValidator('lastname')"
							class="w-full"
							placeholder="Nom"
							v-model="contact.lastname"
							@change="validateOne(contact.lastname, 'lastname')"
						/>
					</vx-input-group>
					<vx-tooltip
						v-if="
							validators['lastname'] && validators['lastname'].errText !== ''
						"
						:text="errText('lastname')"
						class="ml-3"
					>
						<vs-icon icon="error" size="medium" style="color: red"></vs-icon>
					</vx-tooltip>
					<!-- /LAST NAME -->
				</div>
			</div>
			<div class="vx-row mt-5">
				<div
					class="vx-col sm:w-1/2 w-full mb-2 flex"
					style="white-space: nowrap"
				>
					<!-- EMAIL -->
					<vx-input-group class="w-full bottom">
						<template slot="prepend">
							<div class="prepend-text bg-primary">
								<span class="flex"
									><vs-icon icon="alternate_email" size="small"></vs-icon
								></span>
							</div>
						</template>

						<vs-input
							v-model="contact.email"
							placeholder="Email"
							@change="validateOne(contact.email, 'email')"
						/>
					</vx-input-group>
					<vx-tooltip
						v-if="validators['email'] && validators['email'].errText !== ''"
						:text="errText('email')"
						class="ml-3"
					>
						<vs-icon icon="error" size="medium" style="color: red"></vs-icon>
					</vx-tooltip>
					<!-- /EMAIL -->
				</div>
				<div
					class="vx-col sm:w-1/2 w-full mb-2 flex"
					style="white-space: nowrap"
				>
					<!-- PHONE -->
					<vx-input-group class="w-full bottom">
						<template slot="prepend">
							<div class="prepend-text bg-primary">
								<span class="flex"
									><vs-icon icon="local_phone" size="small"></vs-icon
								></span>
							</div>
						</template>

						<!-- <vs-input
              v-model="contact.phone"
              placeholder="Téléphone"
              :success="ContactValidationObjects.phoneValidationObject.valid" :danger="ContactValidationObjects.phoneValidationObject.notValid"
              :success-text="ContactValidationObjects.phoneValidationObject.validText" :danger-text="ContactValidationObjects.phoneValidationObject.errText"
            /> -->
						<vs-input
							:style="styleValidator('phone')"
							v-model="contact.phone"
							placeholder="Téléphone"
							@change="validateOne(contact.phone, 'phone')"
						/>
					</vx-input-group>
					<vx-tooltip
						v-if="validators['phone'] && validators['phone'].errText !== ''"
						:text="errText('phone')"
						class="ml-3"
					>
						<vs-icon icon="error" size="medium" style="color: red"></vs-icon>
					</vx-tooltip>
					<!-- /PHONE -->
				</div>
			</div>
			<div class="vx-row">
				<div class="vx-col sm:w-1/2 w-full mb-2" style="white-space: nowrap">
					<vs-select
						autocomplete
						v-model="contact.type"
						class="w-1/2 select-large mt-4"
						label="Type de contact"
					>
						<vs-select-item
							:key="index"
							:value="item.value"
							:text="item.text"
							v-for="(item, index) in typeOptions"
							class="w-full"
						/>
					</vs-select>
					<vx-tooltip
						v-if="validators['type'] && validators['type'].errText !== ''"
						:text="errText('type')"
						class="ml-3"
					>
						<vs-icon icon="error" size="medium" style="color: red"></vs-icon>
					</vx-tooltip>
				</div>
				<div
					class="vx-col sm:w-1/2 w-full mb-2"
					v-if="this.$route.params.societyId"
					style="display: flex"
				>
					<!-- FONCTION -->
					<vx-input-group class="w-full bottom">
						<template slot="prepend">
							<div class="prepend-text bg-primary">Fonction</div>
						</template>
						<vs-input
							class="w-full"
							placeholder="Fonction du contact (PDG, Directeur marketing...)"
							v-model="contact.fonction"
						/>
					</vx-input-group>
					<!-- /FONCTION -->
				</div>
				<vs-checkbox class="inline-flex mt-4" v-model="contact.hasAccess"
					>Accès au dashboard</vs-checkbox
				>
			</div>
			<div class="vx-row right_element">
				<div class="vx-col">
					<!-- <vs-button
            color="warning"
            type="border"
            class="mb-2 mr-3"
            @click="resetFields"
            >Réinitialiser</vs-button
          > -->
					<vs-button class="mb-2" @click="validateAll">Enregistrer</vs-button>
				</div>
			</div>
		</div>
	</vx-card>
</template>

<script>
import { Contact } from "@/entities/Contact";
import Validator from "@/entities/Validator";
import utilsMixin from "@/mixins/utilsMixin";
import validatorMixin from "@/mixins/validatorMixin";
import VxTooltip from "./../../../components/widgets/vx-tooltip/VxTooltip.vue";

export default {
	name: "ContactForm",
	props: {
		chartParams: Object,
		isPercent: Boolean,
	},
	components: { VxTooltip },
	mixins: [utilsMixin, validatorMixin],
	data() {
		return {
			// USER OBJECT
			contact: Contact.getFormFields(),
			contactOld: Contact.getFormFields(),
			apiUrl: this.$store.state.backendApiUrl,
			society_name: "",
			// FORM SELECT OPTIONS
			typeOptions: [
				{ text: "Facturation", value: 1 },
				{ text: "Commercial", value: 2 },
				{ text: "Technique", value: 5 },
				{ text: "Collaborateur externe", value: 7 },
			],
			societyOptions: new Array(),
			// CONTACT VALIDATORS
			ContactValidationObjects: {
				civilityValidationObject: {
					valid: false,
					notValid: false,
					validText: null,
					errText: null,
					constraintName: "civilityConstraint",
					required: true,
				},
				firstnameValidationObject: {
					valid: false,
					notValid: false,
					validText: null,
					errText: null,
					constraintName: "firstnameConstraint",
					required: true,
				},
				lastnameValidationObject: {
					valid: false,
					notValid: false,
					validText: null,
					errText: null,
					constraintName: "lastnameConstraint",
					required: true,
				},
				typeValidationObject: {
					valid: false,
					notValid: false,
					validText: null,
					errText: null,
					constraintName: "typeConstraint",
					required: true,
				},
				emailValidationObject: {
					valid: false,
					notValid: false,
					validText: null,
					errText: null,
					constraintName: "emailConstraint",
					required: true,
				},
				/*
				 * phoneValidationObject: {
				 *   valid: false,
				 *   notValid: false,
				 *   validText: null,
				 *   errText: null,
				 *   constraintName: "phoneConstraint",
				 *   required: true
				 * },
				 */
				hasAccessValidationObject: {
					valid: false,
					notValid: false,
					validText: null,
					errText: null,
					constraintName: "hasAccessConstraint",
					required: true,
				},
			},
			validators: {},
			check: true,
		};
	},
	async created() {
		try {
			let contact = await this.$http.get(
				this.apiUrl + "users/get/" + this.$route.params.contactId
			);
			this.contact = new Contact(contact.data[0]);
			this.contactOld = new Contact(contact.data[0]);
			this.society_name = this.$route.params.societyId
				? this.getSocietyName(this.$route.params.societyId)
				: "";
			//GET
			if (this.$route.params.societyId) {
				this.society_name = this.$route.params.societyId
					? this.getSocietyName(this.$route.params.societyId)
					: "";
			}

			if (this.$route.params.providerId) {
				this.society_name = this.getProviderName(this.$route.params.providerId);
			}
		} catch (e) {
			//console.log(e);
		}
	},
	beforeUnmount() {
		// Find and remove any lingering tooltip elements
		const tooltips = document.querySelectorAll(".vx-tooltip-content");
		tooltips.forEach((tooltip) => tooltip.remove());
	},
	methods: {
		validateOne(val, name) {
			let value = val;
			value == 0 ? (value = "0") : "";
			let constname = name + "Constraint";
			this.validators[name] = new Validator({ constraintName: constname });
			this.validators[name].check(value);
			this.validators[name].errText == "" &&
			this.validators[name].valid == false
				? (this.validators[name].errText = "Ce champ ne peut être vide.")
				: "";
			this.validators[name].valid == false ? (this.check = false) : "";
			this.$forceUpdate();
		},
		errText(name) {
			if (this.validators[name] && this.validators[name].errText !== "") {
				return this.validators[name].errText;
			}
		},
		styleValidator(name) {
			if (this.validators[name] && this.validators[name].valid == false) {
				if (name == "type") {
					return "border: 1px solid red !important; border-radius: 5px 5px 5px 5px;";
				} else {
					return "border: 1px solid red !important; border-radius: 0 5px 5px 0;";
				}
			} else if (this.validators[name] && this.validators[name].valid == true) {
				if (name == "type") {
					return "border: 1px solid green !important; border-radius: 5px 5px 5px 5px;";
				} else {
					return "border: 1px solid green !important; border-radius: 0 5px 5px 0;";
				}
			} else {
			}
		},
		validateAll() {
			this.check = true;
			let fields = [
				"firstname",
				"lastname",
				"civility",
				"phone",
				"type",
				"email",
			];
			if (!this.contact.firstname) this.contact.firstname = "Inconnu";
			if (!this.contact.lastname) this.contact.lastname = "Inconnu";
			if (!this.contact.phone) this.contact.phone = "0000000000";
			for (let i = 0; i < fields.length; i++) {
				let name = fields[i] + "Constraint";
				let value = this.contact[fields[i]];
				value == 0 ? (value = "0") : "";
				this.validators[fields[i]] = new Validator({ constraintName: name });
				this.validators[fields[i]].check(value);
				this.validators[fields[i]].errText == "" &&
				this.validators[fields[i]].valid == false
					? (this.validators[fields[i]].errText = "Ce champ ne peut être vide.")
					: "";
				this.validators[fields[i]].valid == false ? (this.check = false) : "";
				this.$forceUpdate();
			}
			this.check == true ? this.formSubmitted() : "";
		},

		/**
		 * Send the data to tha API to create the new user
		 * If the form is successfully sent, the user is redirect to Client.vue
		 */
		formSubmitted() {
			//UPDATE
			if (!this.contact.compare(this.contactOld)) {
				this.$http
					.post(this.apiUrl + "users/updatec", {
						user: {
							id: this.$route.params.contactId,
							email: this.contact.email,
							firstname: this.contact.firstname,
							lastname: this.contact.lastname,
							phone: this.contact.phone,
							civility: this.contact.civility,
							type: this.contact.type,
							hasAccess: this.contact.hasAccess,
						},
					})
					.then(() => {
						if (this.$route.params.societyId) {
							this.$http.post(this.apiUrl + "usersSocieties/update/qb/mail", {
								society_id: this.$route.params.societyId,
								mails: this.contact.email,
								oldEmail: this.contactOld.email,
							});
						}
						if (
							this.contactOld.type != this.contact.type ||
							this.contactOld.fonction != this.contact.fonction
						) {
							let relAction = "usersSocieties/updateType";
							let relParam = {
								users_id: this.$route.params.contactId,
								type: this.contact.type,
							};

							if (this.$route.params.providerId)
								relParam["provider_id"] = this.$route.params.providerId;
							if (this.$route.params.societyId) {
								relParam["society_id"] = this.$route.params.societyId;
								relParam["fonction"] = this.contact.fonction;
							}
							//console.log("relParam", relParam);
							if (this.$route.params.providerId)
								relAction = "usersProviders/updateType";
							this.$http
								.post(this.apiUrl + relAction, relParam)
								.then(() => {
									// Send a success notification to the user
									this.$vs.notify({
										title: "Succès",
										text: "Contact modifié avec succès.",
									});
									// Send the user to the previous route
									this.$router.go(-1);
								})
								.catch((err) => {
									//console.log(err);
								});
						} else {
							// Send a success notification to the user
							this.$vs.notify({
								title: "Succès",
								text: "Contact modifié avec succès.",
							});
							// Send the user to the previous route
							this.$router.go(-1);
						}
					});
			} else {
				this.$vs.notify({
					title: "Aucune modification",
					text: "Le contact n'a pas été modifié.",
				});
			}
		},

		/**
		 * Gets society name from Id
		 * @param {Number} societyId - Society's ID to get name from
		 * @return {String} - Returns Society's name
		 */
		getSocietyName(societyId) {
			for (let society of this.$store.state.societies) {
				if (societyId == society.id) {
					return society.name;
				}
			}
			return "Entreprise non renseignée";
		},

		getProviderName(providerId) {
			for (let provider of this.$store.state.providers) {
				if (providerId == provider.id) {
					return provider.society;
				}
			}
			return "Entreprise non renseignée";
		},

		/**
		 * Checks if type is valid
		 */
		checkType() {
			this.checkHandler(
				this.contact.type,
				this.ContactValidationObjects.typeValidationObject
			);
		},

		/**
		 * Redirect to the previous page
		 */
		returnPrevRoute() {
			this.$router.go(-1);
		},
	},
};
</script>

<style scoped>
.inlineB {
	display: inline-block;
}

.role_selector_container {
	justify-content: space-between;
	width: 40%;
}

.role_container {
	justify-content: center;
}

.space_div {
	margin: 5px;
}

.bottom {
	align-self: flex-end;
}

.center {
	align-self: center;
}

.right_element {
	justify-content: flex-end;
}
</style>
